import React from"react";export function forwardRefWithAs(a){return React.forwardRef(a)}
//# sourceMappingURL=PropsWithAsAttributes.js.map